import React from 'react';

const SliderLoader = () => {
  return (
    <div className='hero__loading'>
      <div className='box loader-05'>
        <div className='loader-05' />
      </div>
    </div>
  );
};

export default SliderLoader;
